
import { css } from 'lit';
export default css`
.cta-card-hero__wrapper {
  position: relative;
}
  .cta-card-hero__wrapper {
  display: flex;
}
  .cta-card-hero__wrapper {
  flex-direction: column;
}
  @media (min-width: 768px) {
  .cta-card-hero__wrapper {
    flex-direction: row;
  }
}
  @media (min-width: 768px) {
  .cta-card-hero__image {
    position: relative;
  }
}
  @media (min-width: 768px) {
  .cta-card-hero__image {
    display: flex;
  }
}
  @media (min-width: 1024px) {
  .cta-card-hero__image {
    margin-top: 1.5rem;
  }
}
  .cta-card-hero__image {
    order: -1;
  }
  @media (min-width: 768px) {
  .cta-card-hero__image {
      order: initial;
      width: 50%
  }
    }
  .cta-card-hero__content {
  margin-top: 3rem;
}
  .cta-card-hero__content {
  display: block;
}
  .cta-card-hero__content {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}
  @media (min-width: 768px) {
  .cta-card-hero__content {
    max-width: 50%;
  }
}
  @media (min-width: 768px) {
  .cta-card-hero__content {
    padding-right: 3rem;
  }
}
  .cta-card-hero__title {
  margin-bottom: 0.75rem;
}
  .cta-card-hero__text {
  margin-bottom: 2rem;
}
  .cta-card-hero__card-wrapper {
  display: flex;
}
  .cta-card-hero__card-wrapper {
  max-width: 100%;
}
  .cta-card-hero__card-wrapper {
  flex-direction: row;
}
  @media (min-width: 1024px) {
  .cta-card-hero__card-wrapper {
    padding-top: 1rem;
  }
}
  .cta-card-hero__card-wrapper > *:first-child {
  padding-right: 1rem;
}
  @media (min-width: 768px) {
  .cta-card-hero__card-wrapper > *:first-child {
    padding-right: 1.5rem;
  }
}
  @media (min-width: 1200px) {
  .cta-card-hero__card-wrapper > *:first-child {
    padding-right: 2rem;
  }
}
  @media (min-width: 1366px) {
  .cta-card-hero__card-wrapper > *:first-child {
    padding-right: 2.5rem;
  }
}
  .cta-card-hero__card-wrapper > *:nth-child(2) {
  border-left-width: 1px;
}
  .cta-card-hero__card-wrapper > *:nth-child(2) {
  --tw-border-opacity: 1;
  border-color: rgba(232, 194, 255, var(--tw-border-opacity));
}
  .cta-card-hero__card-wrapper > *:nth-child(2) {
  padding-left: 1rem;
}
  @media (min-width: 768px) {
  .cta-card-hero__card-wrapper > *:nth-child(2) {
    padding-left: 1.5rem;
  }
}
  @media (min-width: 1200px) {
  .cta-card-hero__card-wrapper > *:nth-child(2) {
    padding-left: 2rem;
  }
}
  @media (min-width: 1366px) {
  .cta-card-hero__card-wrapper > *:nth-child(2) {
    padding-left: 2.5rem;
  }
}
  .cta-card-hero__card-link {
    flex: 1;
  }
  .cta-card-hero__card-link a {
  display: flex;
}
  .cta-card-hero__card-link a {
  flex-direction: row;
}
  .cta-card-hero__card-icon {
  margin-bottom: 1.25rem;
}
  .cta-card-hero__card-icon {
  height: 3rem;
}
  .cta-card-hero__card-icon {
  width: 3rem;
}
  .cta-card-hero__card-icon {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}
  .cta-card-hero__card-text {
  font-size: 1.125rem;
}
  .cta-card-hero__card-text {
  font-weight: 700;
}
  @media (min-width: 1024px) {
  .cta-card-hero__card-text {
    font-size: 1.25rem;
  }
}
  .cta-card-hero__card-copy-text {
  margin-bottom: 0.75rem;
}
  .cta-card-hero__card-copy-text {
  font-weight: 700;
}
  @media (min-width: 1024px) {
  .cta-card-hero__card-copy-text {
    margin-bottom: 1.25rem;
  }
}
  .cta-card-hero__card-copy-text {
    font-size: 1.1rem;
  }
  @media (min-width: 1024px) {
  .cta-card-hero__card-copy-text {
      font-size: 1.38rem
  }
    }
  .cta-card-hero__card-title {
  position: relative;
}
  .cta-card-hero__card-title {
  margin-bottom: 0.75rem;
}
  .cta-card-hero__card-title {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}
  .cta-card-hero__card-title {
    font-size: 1.5rem;
    margin-right: 1.2rem;
  }
  @media (min-width: 1024px) {
  .cta-card-hero__card-title {
      font-size: 2.15rem
  }
    }
  .cta-card-hero__card-arrow {
  margin-top: 2px;
}
  .cta-card-hero__card-arrow {
  margin-left: 0.5rem;
}
  .cta-card-hero__card-arrow {
  display: inline-block;
}
  .cta-card-hero__card-arrow {
  height: 1rem;
}
  .cta-card-hero__card-arrow {
  width: 1rem;
}
  .cta-card-hero__card-arrow {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}
  @media (min-width: 1024px) {
  .cta-card-hero__card-arrow {
    margin-top: 0.5rem;
  }
}
  @media (min-width: 1024px) {
  .cta-card-hero__card-arrow {
    margin-left: 0.5rem;
  }
}
  .cta-card-hero__card-arrow {
    position: absolute;
  }
  .cta-card-hero__card-link:hover .cta-card-hero__card-title, .cta-card-hero__card-link:hover .cta-card-hero__card-arrow, .cta-card-hero__card-link:hover .cta-card-hero__card-icon {
  --tw-text-opacity: 1;
  color: rgba(53, 25, 108, var(--tw-text-opacity));
}
  .cta-card-hero__card-link:hover .cta-card-hero__card-title, .cta-card-hero__card-link:hover .cta-card-hero__card-arrow, .cta-card-hero__card-link:hover .cta-card-hero__card-icon {
  text-decoration: underline;
}

.whitespace-nowrap {
  white-space: nowrap;
}`;